import React from "react";
import { BLACK, BORDER, CARD_BG, FONT, GOLD_DARK, GOLD_TINT, TEXT_MUTED } from "../ProposalFlow/theme";

// The anonymous tools' (PDP audit, Consumer Voice, AI Presence) next step:
// register — the account inherits the product, the analysis and any
// strategy (lib/funnelClaim on the API) — or build a strategy first, which
// asks them to register once it is saved. Logged-out visitors only; the
// callers gate it.
export default function FunnelChoiceCard({
    registerHref,
    strategyHref,
    onStrategy,
    strategyLabel = "Build a strategy",
    testId
}: {
    registerHref: string;
    strategyHref?: string;
    onStrategy?: () => void;
    strategyLabel?: string;
    testId?: string;
}) {
    const buttonBase: React.CSSProperties = {
        fontFamily: FONT,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 15,
        fontWeight: 700,
        borderRadius: 8,
        padding: "13px 22px",
        textDecoration: "none",
        cursor: "pointer",
        flex: "1 1 220px",
        boxSizing: "border-box"
    };
    const strategyStyle: React.CSSProperties = {
        ...buttonBase,
        background: CARD_BG,
        color: BLACK,
        border: `1.5px solid ${BORDER}`
    };
    return (
        <div
            data-testid={testId}
            style={{
                fontFamily: FONT,
                background: GOLD_TINT,
                border: `1px solid ${BORDER}`,
                borderRadius: 12,
                padding: "22px 24px",
                margin: "20px 0"
            }}
        >
            <div style={{ fontSize: 19, fontWeight: 700, color: BLACK, marginBottom: 6 }}>
                Get started with this product — free
            </div>
            <div style={{ fontSize: 14, color: TEXT_MUTED, lineHeight: 1.55, marginBottom: 16 }}>
                Your product, this analysis and any strategy you build come with you.
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                <a
                    href={registerHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...buttonBase, background: GOLD_DARK, color: "#fff", border: "1.5px solid transparent" }}
                >
                    Create your free account →
                </a>
                {strategyHref && (
                    <a href={strategyHref} target="_blank" rel="noopener noreferrer" style={strategyStyle}>
                        {strategyLabel}
                    </a>
                )}
                {!strategyHref && onStrategy && (
                    <button type="button" onClick={onStrategy} style={strategyStyle}>
                        {strategyLabel}
                    </button>
                )}
            </div>
        </div>
    );
}
